/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Vector3dPb } from "../../../../gen/eigen_lcm/Vector3d";

export const protobufPackage = "skills";

export interface ToggleTargetPointExposureActionArgs {
  /**
   * If true, we will enable periodic target point exposure requests in the nav cameras with the
   * parameters below
   */
  enable: boolean;
  /** If used, take photo every time_interval seconds */
  timeInterval: number;
  navTTarget: Vector3dPb | undefined;
  targetRadius: number;
}

export interface ToggleTargetPointExposureResultData {
}

export interface ToggleTargetPointExposureActionStateData {
}

function createBaseToggleTargetPointExposureActionArgs(): ToggleTargetPointExposureActionArgs {
  return { enable: false, timeInterval: 0, navTTarget: undefined, targetRadius: 0 };
}

export const ToggleTargetPointExposureActionArgs = {
  encode(message: ToggleTargetPointExposureActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.enable === true) {
      writer.uint32(8).bool(message.enable);
    }
    if (message.timeInterval !== 0) {
      writer.uint32(21).float(message.timeInterval);
    }
    if (message.navTTarget !== undefined) {
      Vector3dPb.encode(message.navTTarget, writer.uint32(26).fork()).ldelim();
    }
    if (message.targetRadius !== 0) {
      writer.uint32(37).float(message.targetRadius);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleTargetPointExposureActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleTargetPointExposureActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.enable = reader.bool();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.timeInterval = reader.float();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.navTTarget = Vector3dPb.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.targetRadius = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleTargetPointExposureActionArgs {
    return {
      enable: isSet(object.enable) ? globalThis.Boolean(object.enable) : false,
      timeInterval: isSet(object.timeInterval) ? globalThis.Number(object.timeInterval) : 0,
      navTTarget: isSet(object.navTTarget) ? Vector3dPb.fromJSON(object.navTTarget) : undefined,
      targetRadius: isSet(object.targetRadius) ? globalThis.Number(object.targetRadius) : 0,
    };
  },

  toJSON(message: ToggleTargetPointExposureActionArgs): unknown {
    const obj: any = {};
    if (message.enable === true) {
      obj.enable = message.enable;
    }
    if (message.timeInterval !== 0) {
      obj.timeInterval = message.timeInterval;
    }
    if (message.navTTarget !== undefined) {
      obj.navTTarget = Vector3dPb.toJSON(message.navTTarget);
    }
    if (message.targetRadius !== 0) {
      obj.targetRadius = message.targetRadius;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleTargetPointExposureActionArgs>, I>>(
    base?: I,
  ): ToggleTargetPointExposureActionArgs {
    return ToggleTargetPointExposureActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleTargetPointExposureActionArgs>, I>>(
    object: I,
  ): ToggleTargetPointExposureActionArgs {
    const message = createBaseToggleTargetPointExposureActionArgs();
    message.enable = object.enable ?? false;
    message.timeInterval = object.timeInterval ?? 0;
    message.navTTarget = (object.navTTarget !== undefined && object.navTTarget !== null)
      ? Vector3dPb.fromPartial(object.navTTarget)
      : undefined;
    message.targetRadius = object.targetRadius ?? 0;
    return message;
  },
};

function createBaseToggleTargetPointExposureResultData(): ToggleTargetPointExposureResultData {
  return {};
}

export const ToggleTargetPointExposureResultData = {
  encode(_: ToggleTargetPointExposureResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleTargetPointExposureResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleTargetPointExposureResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ToggleTargetPointExposureResultData {
    return {};
  },

  toJSON(_: ToggleTargetPointExposureResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleTargetPointExposureResultData>, I>>(
    base?: I,
  ): ToggleTargetPointExposureResultData {
    return ToggleTargetPointExposureResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleTargetPointExposureResultData>, I>>(
    _: I,
  ): ToggleTargetPointExposureResultData {
    const message = createBaseToggleTargetPointExposureResultData();
    return message;
  },
};

function createBaseToggleTargetPointExposureActionStateData(): ToggleTargetPointExposureActionStateData {
  return {};
}

export const ToggleTargetPointExposureActionStateData = {
  encode(_: ToggleTargetPointExposureActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ToggleTargetPointExposureActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleTargetPointExposureActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ToggleTargetPointExposureActionStateData {
    return {};
  },

  toJSON(_: ToggleTargetPointExposureActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleTargetPointExposureActionStateData>, I>>(
    base?: I,
  ): ToggleTargetPointExposureActionStateData {
    return ToggleTargetPointExposureActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleTargetPointExposureActionStateData>, I>>(
    _: I,
  ): ToggleTargetPointExposureActionStateData {
    const message = createBaseToggleTargetPointExposureActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
